import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom/client';
import AppWrapper from "./routing/AppWrapper";
import "@fontsource/roboto";
import "./global.css";
const rootElement = document.getElementById('root');
if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(_jsx(AppWrapper, {}));
}
else {
    console.error('Root element not found');
}
